// Checks if the any of the currently selected blocks are of `type`.
const hasBlock = (value, type) => value.blocks.some(node => node.type === type);

export default hasBlock;
